module.exports = __webpack_public_path__ + "static/media/logo-horizontal.fd55c178.svg";